import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ palette, spacing }) => ({
		root: {
			paddingLeft: spacing(3.25),
			paddingRight: spacing(3.25),
			'&:hover': {
				'& $deleteButton, $dragButton': {
					opacity: 1,
				},
			},
			'& $checkIcon': {
				position: 'absolute',
				top: '50%',
				transform: 'translateY(-50%)',
				left: spacing(0.5),
				color: palette.primary.main,
				zipIndex: 0,
			},
		},
		deleteButton: {
			position: 'absolute',
			top: 0,
			height: '100%',
			right: 0,
			padding: spacing(0.75),
			borderRadius: 0,
			color: ({ type }) => {
				return palette.calcContrastColor(
					palette.scoreapp.secondary,
					type === 'checkbox' ? palette.background.default : palette.primary.main,
				)
			},
			zIndex: 0,
			opacity: 0,
			transition: 'opacity 0.15s ease',
		},
		deleting: {
			color: ({ type }) => {
				return palette.calcContrastColor(
					palette.scoreapp.secondary,
					type === 'checkbox' ? palette.background.default : palette.primary.main,
				)
			},
		},
		dragButton: {
			color: ({ type }) => {
				return palette.calcContrastColor(
					palette.scoreapp.primary,
					type === 'checkbox' ? palette.background.default : palette.primary.main,
				)
			},
			zIndex: 0,
			opacity: 0,
			transition: 'opacity 0.15s ease',
		},
		checkIcon: {},
		startIcon: {
			margin: 0,
		},
	}),
	{ name: 'Questions-AnswerTypes-OptionButton' },
)

export default useStyles
